<template>
  <div class="p-abtest-edit-preview-list__item">
    <div class="p-abtest-edit-preview-content">
      <div class="p-abtest-edit-preview-content-row">
        <div class="p-abtest-edit-preview-content__title">性別</div>
        <div class="p-abtest-edit-preview-content__text">
          <span v-for="(gender, loopIndex1) in genders" :key="loopIndex1">{{ getDescription(gender) }}</span>
        </div>
      </div>
      <div class="p-abtest-edit-preview-content-row">
        <div class="p-abtest-edit-preview-content__title">年齢</div>
        <div class="p-abtest-edit-preview-content__text">
          <span v-for="(age, loopIndex2) in ages" :key="loopIndex2">{{ getDescription(age) }}</span>
        </div>
      </div>
      <div class="p-abtest-edit-preview-content-row">
        <div class="p-abtest-edit-preview-content__title">地域</div>
        <div class="p-abtest-edit-preview-content__text">
          <span v-for="(region, loopIndex3) in regions" :key="loopIndex3">{{ getDescription(region) }}</span>
        </div>
      </div>
      <div class="p-abtest-edit-preview-content-row">
        <div class="p-abtest-edit-preview-content__title">企業</div>
        <div class="p-abtest-edit-preview-content__text">
          <span v-for="(company, loopIndex4) in companies" :key="loopIndex4">{{ getDescription(company) }}</span>
        </div>
      </div>
      <!-- <div class="p-abtest-edit-preview-content-row">
            <div class="p-abtest-edit-preview-content__title">オーディエンス</div>
            <div class="p-abtest-edit-preview-content__text">
                <span v-for="audience in audiences">{{ getDescription(audience) }}</span>
            </div>
        </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    topicCondition: Object,
  },
  computed: {
    ages: function () {
      return this.topicCondition.topic_condition_details.filter(topicConditionDetail =>
        topicConditionDetail.data_type == 'age'
      );
    },
    regions: function () {
      return this.topicCondition.topic_condition_details.filter(topicConditionDetail =>
        topicConditionDetail.data_type == 'pref'
      );
    },
    genders: function () {
      return this.topicCondition.topic_condition_details.filter(topicConditionDetail =>
        topicConditionDetail.data_type == 'sex'
      );
    },
    audiences: function () {
      return this.topicCondition.topic_condition_details.filter(topicConditionDetail =>
        topicConditionDetail.data_type == 'interest' || topicConditionDetail.data_type == 'keyword'
      );
    },
    companies: function () {
      return this.topicCondition.topic_condition_details.filter(topicConditionDetail =>
        topicConditionDetail.data_type == 'company'
      );
    },
  },
  mounted: function () {
  },
  methods: {
    getDescription: function (topicConditionDetail) {
      let dataType = topicConditionDetail.data_type;
      let description = '不明';
      if (dataType == 'age') {
        description = topicConditionDetail.condition_1 + '歳-' + topicConditionDetail.condition_2 + '歳';
      } else if (dataType == 'pref') {
        description = topicConditionDetail.condition_1;
      } else if (dataType == 'sex') {
        description = topicConditionDetail.condition_1;
      } else if (dataType == 'interest') {
        description = topicConditionDetail.condition_1;
      } else if (dataType == 'keyword') {
        description = topicConditionDetail.condition_1;
      } else if (dataType == 'company') {
        description = '企業ユーザー';
      }
      return description;
    },
  }
};
</script>
